import "./TemplafyLogo_module.css";
const TemplafyLogo_module = {
    templafyLogo: "templafyLogo__2b5ec88ee3dc1aa2"
};
export { TemplafyLogo_module as default };
